<div class="row">
    <div [ngSwitch]="question.answerType" class="col-11 p-l-15 p-b-10">
        <div *ngSwitchCase="questionType.Text">
            <app-text-form [question]="questionWithOrderedAnswers" (questionAnswered)="onQuestionAnswered($event)">
            </app-text-form>
        </div>
        <div *ngSwitchCase="questionType.Number">
            <app-text-form [question]="questionWithOrderedAnswers" (questionAnswered)="onQuestionAnswered($event)">
            </app-text-form>
        </div>
        <div *ngSwitchCase="questionType.Checkbox">
            <app-checkbox-radio-form [question]="questionWithOrderedAnswers" (questionAnswered)="onQuestionAnswered($event)">
            </app-checkbox-radio-form>
        </div>
        <div *ngSwitchCase="questionType.Radiobutton">
            <app-checkbox-radio-form [question]="questionWithOrderedAnswers" (questionAnswered)="onQuestionAnswered($event)">
            </app-checkbox-radio-form>
        </div>
        <div *ngSwitchCase="questionType.Rating">
            <app-checkbox-radio-form [question]="questionWithOrderedAnswers" (questionAnswered)="onQuestionAnswered($event)">
            </app-checkbox-radio-form>
        </div>
        <div *ngSwitchCase="questionType.SatisfactionRate">
                <app-checkbox-radio-form [question]="questionWithOrderedAnswers" (questionAnswered)="onQuestionAnswered($event)">
                </app-checkbox-radio-form>
        </div>
        <div *ngSwitchCase="questionType.MatrixRadiobutton">
            <app-matrix-form (questionAnswered)="onQuestionAnswered($event)" [question]="questionWithOrderedAnswers"></app-matrix-form>
        </div>
        <div *ngSwitchCase="questionType.MatrixCheckbox">
            <app-matrix-form (questionAnswered)="onQuestionAnswered($event)" [question]="questionWithOrderedAnswers"></app-matrix-form>
        </div>
        <div *ngSwitchDefault>
            <app-text-form [question]="questionWithOrderedAnswers"></app-text-form>
        </div>
    </div>
    <div class="col-1" *ngIf="questionWithOrderedAnswers.isMandatory">
        <div class="col-12 clearfix m-t-10 mandatory-question">
        </div>
    </div>
</div>